import { defineComponent as n, createBlock as r, openBlock as l, unref as p, mergeProps as v, withCtx as m, createElementVNode as a } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const i = /* @__PURE__ */ n({
  name: "IconMagsafe",
  __name: "IconMagsafe",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (c, e) => (l(), r(p(s), v(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        a("path", { d: "M12 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M6 2.75A1.75 1.75 0 0 0 4.25 4.5v.418a1.75 1.75 0 0 0-1 1.582v10A1.75 1.75 0 0 0 5 18.25h6.25v2.25a.75.75 0 0 0 1.5 0v-2.25H19a1.75 1.75 0 0 0 1.75-1.75v-10a1.75 1.75 0 0 0-1-1.582V4.5A1.75 1.75 0 0 0 18 2.75H6m13 14H5a.25.25 0 0 1-.25-.25v-10A.25.25 0 0 1 5 6.25h14a.25.25 0 0 1 .25.25v10A.25.25 0 0 1 19 16.75m-.75-12V4.5A.25.25 0 0 0 18 4.25H6A.25.25 0 0 0 5.75 4.5v.25h12.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  i as default
};
